<div class="main-content" *ngIf="isReady">
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-atom"></ngx-spinner>

    <app-grid [title]="title" [route]="route" [columns]="columns" [model]="dataSource" [extraButtons]="extraButtons"  [gridMainButtons] = "gridMainButtons"
        [dtOptions]="dtOptions" (buttonClicked)="handleClick($event)" (filterData)="filterData($event)" [tableFilters]="tableFilters"
              [gridActions]="[{key: 'edit', show: true, icon: 'fa fa-edit', cssClasses: ['bg-warning', 'btn-icon', 'btn-sm', 'fs-1', 'fw-bold', 'mr-1'],tooltip:'Ndrysho'}, {key: 'delete', show: true, icon: 'fa fa-remove', cssClasses: ['bg-danger', 'btn-icon', 'btn-sm', 'fs-1', 'fw-bold', 'mr-1'],tooltip:'Fshi'}]">
    </app-grid>
</div>
